module.exports = __webpack_public_path__ + "img/reference-vssoe.c6b98563.webp";